import { useState } from 'react';
import { t } from 'i18next';
import { Table } from 'semantic-ui-react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ImageViewModal from '../../../../components/elements/ImageViewModal';

export function DetailAccordion({ handleDocLoad, header, mediaData: data, handleFileDownload, title }) {
  const [showModal, setShowModal] = useState(false);
  const [renderLink, setRenderLink] = useState('');
  const tableRows = ['sNo', 'File Name', 'Action'];
  const headings = ['Donor ID', 'Death Certificate', 'Approval Letter'];

  const openModal = async (e, image) => {
    e.preventDefault();

    setRenderLink(image);
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        // onClick={(e) => {
        //   if (limitRequest) {
        //     handleDocLoad(e);
        //   }
        // }}
      >
        <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t(`${title}`)}</h2>
      </AccordionSummary>
      <AccordionDetails>
        {data?.map((item, index) => {
          return (
            <div key={index} className="container-fluid">
              <div className="">
                <div className="form-group">
                  <label className="text-gray-700 p-2  text-sm">
                    {t(`${header ? header[index] : headings[index]}`)}
                  </label>
                </div>
              </div>

              <div className="relative overflow-x-auto ">
                <Table className="text-sm tableData text-left rtl:text-right ">
                  <Table.Header className="font-bold text-white bg-customgreen uppercase ">
                    <Table.Row>
                      {tableRows.map((item, index) => {
                        return (
                          <Table.HeaderCell key={index} className=" text-white">
                            {t(`${item}`)}
                          </Table.HeaderCell>
                        );
                      })}
                    </Table.Row>
                  </Table.Header>
                  <Table.Body className="tableData whitespace-nowrap">
                    <Table.Row>
                      <Table.Cell className="tableCell cursor-not-allowed">{t(`${1}`)}</Table.Cell>
                      <Table.Cell className="cursor-not-allowed">
                        {t(`${item.fileName ? item.fileName : 'Not Available'}`)}
                      </Table.Cell>
                      <Table.Cell>
                        <div className="flex flex-col  items-center sm:flex-row sm:space-x-2">
                          <button
                            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                            disabled={!item.doc}
                            style={{
                              margin: '5px',
                            }}
                            onClick={(e) => {
                              handleFileDownload(e, item.doc, item.fileName);
                            }}
                          >
                            <FileDownloadOutlinedIcon />
                          </button>

                          <button
                            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center sm:ml-2"
                            type="button"
                            // onClick={ () => setShowModal(true) }>
                            onClick={(e) => openModal(e, item.doc)}
                          >
                            <VisibilityOutlinedIcon />
                          </button>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </div>
            </div>
          );
        })}
        <ImageViewModal
          showModal={showModal}
          setShowModal={setShowModal}
          closeModal={closeModal}
          title={''}
          renderLink={''}
          imgDoc={renderLink}
        />
      </AccordionDetails>
    </Accordion>
  );
}
